import { useNavigation } from '@react-navigation/native'
import { publishEvent } from '@zet/analytics'
import { B2, SH2 } from '@zet/design-system/typography'
import { i18n } from '@zet/localization'
import { zetApi } from '@zet/network'

const { locale = 'en' } = zetApi.defaults.headers.common

const TermsAndConditions = () => {
  const navigation = useNavigation()
  return (
    <>
      <B2 className="mb-3">
        {i18n.t('verifyPhNum.agree')}
        <SH2
          onPress={() => {
            publishEvent('click_action', {
              item_name: 'login_signup_terms_of_use',
            })
            navigation.navigate('WebViewScreen', {
              url: 'https://www.zetapp.in/terms-of-use',
            })
          }}
        >
          {' '}
          {i18n.t('verifyPhNum.terms')}
        </SH2>
        <B2>{i18n.t('verifyPhNum.and')}</B2>
        <SH2
          onPress={() => {
            publishEvent('click_action', {
              item_name: 'login_signup_privacy_policy',
            })
            navigation.navigate('WebViewScreen', {
              url: 'https://www.zetapp.in/privacy-policy',
            })
          }}
        >
          {' '}
          {i18n.t('verifyPhNum.privacyPolicy')}
        </SH2>
        <B2>
          {i18n.t('verifyPhNum.agreeSuffix', {
            continue: locale === 'hi' ? i18n.t('verifyPhNum.continue') : '',
          })}
        </B2>
      </B2>
    </>
  )
}
export default TermsAndConditions
